export enum NearbyTrailerResultType {
    customerLocation,
    standaloneTrailer,
    noResultsAtCustomerLocation,
}
